export default __webpack_public_path__ + "static/media/QI-Resources.d66cb1e9.jpeg";